/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class GroupRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    return this.store.findRecord('people-schema/group', params.group_id, {
      include: 'fields',
    });
  }
}
